module.exports = __webpack_public_path__ + "static/media/oval-icon.0519fbcf.svg";